import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Header from "../../layouts/Header";
import Sidebar from "../../layouts/Sidebar";
import "../../_components/antd.css";
import { Table, Modal, Form, Input, Button } from "antd";
import { onShowSizeChange } from "../../_components/paginationfunction";
import AddVendor from "../../customers/vendors/addVendor";
import axios from "axios";

const Expenses = () => {
  const [menu, setMenu] = useState(false);
  const [show, setShow] = useState(false);
  const [expenses, setExpenses] = useState([]);
  const [loading, setLoading] = useState(true);

  // Category modal state
  const [showCategoryModal, setShowCategoryModal] = useState(false);
  const [categoryForm] = Form.useForm();
  const [savingCategory, setSavingCategory] = useState(false);

  const toggleMobileMenu = () => {
    setMenu(!menu);
  };

  useEffect(() => {
    fetchExpenses();
  }, []);

  const fetchExpenses = async () => {
    try {
      setLoading(true);
      const response = await axios.get("/expenses/view-create/");
      setExpenses(response.data);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching expenses:", error);
      setLoading(false);
    }
  };

  const handleAddCategory = async () => {
    try {
      const values = await categoryForm.validateFields();
      setSavingCategory(true);
      await axios.post(
        "/expenses/categories/",
        { name: values.name },
        {
          headers: {
            "X-CSRFToken": document.cookie
              .split("; ")
              .find((row) => row.startsWith("csrftoken="))
              ?.split("=")[1],
          },
        }
      );
      setSavingCategory(false);
      setShowCategoryModal(false);
      categoryForm.resetFields();
      fetchExpenses(); // refresh after adding category
    } catch (error) {
      console.error("Error adding category:", error);
      setSavingCategory(false);
    }
  };

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
    },
    {
      title: "Category",
      dataIndex: "category",
    },
    {
      title: "Date",
      dataIndex: "date",
      sorter: (a, b) => new Date(a.date) - new Date(b.date),
    },
    {
      title: "Amount",
      render: (text, record) =>
        `${window.COMPANY.currency_symbol} ${record.amount} `,
    },
    {
      title: "Invoice Number",
      dataIndex: "invoice_number",
    },
    {
      title: "Notes",
      dataIndex: "notes",
    },
    {
      title: "Created At",
      dataIndex: "created_at",
      render: (text) => new Date(text).toLocaleDateString(),
      sorter: (a, b) => new Date(a.created_at) - new Date(b.created_at),
    },
    {
      title: "Modified At",
      dataIndex: "modified_at",
      render: (text) => new Date(text).toLocaleDateString(),
      sorter: (a, b) => new Date(a.modified_at) - new Date(b.modified_at),
    },
    {
      title: "Customer",
      dataIndex: "customer",
    },
    {
      title: "Action",
      render: (text, row) => (
        <div className="d-flex align-items-center">
          <Link
            className="dropdown-item"
            to="#"
            onClick={async (e) => {
              e.preventDefault();
              if (
                window.confirm("Are you sure you want to delete this expense?")
              ) {
                try {
                  await axios.delete(`/expenses/${row.id}/`, {
                    headers: {
                      "X-CSRFToken": document.cookie
                        .split("; ")
                        .find((row) => row.startsWith("csrftoken="))
                        ?.split("=")[1],
                    },
                  });
                  fetchExpenses();
                } catch (error) {
                  console.error("Error deleting expense:", error);
                }
              }
            }}
          >
            <i className="far fa-trash-alt me-2" />
          </Link>
          <Link className="dropdown-item" to={`/expenses/edit/${row.id}`}>
            <i className="far fa-edit me-2" />
          </Link>
        </div>
      ),
    },
  ];

  return (
    <>
      <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
        <Header onMenuClick={toggleMobileMenu} />
        <Sidebar />

        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="page-header">
              <div className="content-page-header">
                <h5>Expenses</h5>
                <div className="list-btn">
                  <ul className="filter-list">
                    <li>
                      <Link
                        className="btn btn-primary"
                        to="/expenses/add-expenses"
                      >
                        <i
                          className="fa fa-plus-circle me-2"
                          aria-hidden="true"
                        />
                        Add Expenses
                      </Link>
                    </li>
                    <li>
                      <Link
                        className="btn btn-outline-primary"
                        to="#"
                        onClick={() => setShowCategoryModal(true)}
                      >
                        <i className="fa fa-plus me-2" aria-hidden="true" />
                        Add Category
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-sm-12">
                <div className="card-table">
                  <div className="card-body purchase">
                    <div className="table-responsive table-hover">
                      <Table
                        loading={loading}
                        pagination={{
                          total: expenses.length,
                          showTotal: (total, range) =>
                            `Showing ${range[0]} to ${range[1]} of ${total} entries`,
                          onShowSizeChange: onShowSizeChange,
                        }}
                        columns={columns}
                        dataSource={expenses}
                        rowKey="id"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Add Category Modal */}
      <Modal
        title="Add Category"
        visible={showCategoryModal}
        onCancel={() => setShowCategoryModal(false)}
        footer={[
          <Button key="cancel" onClick={() => setShowCategoryModal(false)}>
            Cancel
          </Button>,
          <Button
            key="save"
            type="primary"
            loading={savingCategory}
            onClick={handleAddCategory}
          >
            Save
          </Button>,
        ]}
      >
        <Form form={categoryForm} layout="vertical">
          <Form.Item
            label="Category Name"
            name="name"
            rules={[{ required: true, message: "Please enter category name" }]}
          >
            <Input placeholder="Enter category name" />
          </Form.Item>
        </Form>
      </Modal>

      <AddVendor setShow={setShow} show={show} />
    </>
  );
};

export default Expenses;
